/** All cookies set via createCookie (frontend policy; ignore backend expires_in). */
export const COOKIE_MAX_AGE_MS = 10 * 60 * 60 * 1000;

/** Log out this many ms before stored session end (proactive logout). */
export const SESSION_LOGOUT_LEAD_MS = 5 * 60 * 1000;

/** Show the session warning banner for this long before forced logout. */
export const SESSION_WARN_LEAD_MS = 5 * 60 * 1000;

/** How often we re-read session end and refresh the countdown (tab + interval). */
export const SESSION_CHECK_INTERVAL_MS = 30 * 1000;

export const SESSION_ENDS_AT_STORAGE_KEY = "cap_session_ends_at";

export const setSessionEndsAt = (ms) => {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return;
  }
  window.localStorage.setItem(SESSION_ENDS_AT_STORAGE_KEY, String(ms));
};

export const getSessionEndsAtMs = () => {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return null;
  }
  const raw = window.localStorage.getItem(SESSION_ENDS_AT_STORAGE_KEY);
  if (raw === null || raw === "") {
    return null;
  }
  const parsed = Number.parseInt(raw, 10);
  if (Number.isNaN(parsed)) {
    return null;
  }
  return parsed;
};

export const clearSessionEndsAt = () => {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return;
  }
  window.localStorage.removeItem(SESSION_ENDS_AT_STORAGE_KEY);
};

/**
 * @returns {{
 *   shouldRun: boolean,
 *   shouldLogout?: boolean,
 *   showBanner?: boolean,
 *   minutesRemaining?: number
 * }}
 */
export const evaluateSessionExpiry = (nowMs, sessionEndsAtMs) => {
  if (sessionEndsAtMs === null || typeof sessionEndsAtMs !== "number") {
    return { shouldRun: false };
  }

  const forcedLogoutAt = sessionEndsAtMs - SESSION_LOGOUT_LEAD_MS;

  if (nowMs >= forcedLogoutAt) {
    return { shouldRun: true, shouldLogout: true };
  }

  const warnStartsAt = forcedLogoutAt - SESSION_WARN_LEAD_MS;
  if (nowMs >= warnStartsAt) {
    const msUntilLogout = forcedLogoutAt - nowMs;
    const minutesRemaining = Math.max(1, Math.ceil(msUntilLogout / 60000));
    return { shouldRun: true, showBanner: true, minutesRemaining };
  }

  return { shouldRun: true, showBanner: false };
};
